import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import { auth, db } from "../../firebase";
import firebase from "../../firebase";
import google from "../../assets/google.png";
import brand from "../../assets/images/logos/logo2.png";
import '../../signup.css';
import VerificatonModal from "./VerificationModal";

import {
  Content,
  Input,
  Button,
  Para,
  Logo,
  GoogleButton,
  Google,
} from "./SignIn";
import { userContext } from "../../App";

const SignUp = () => {
  window.scrollTo(0, 0);
  const { state, dispatch } = useContext(userContext);
  const history = useHistory();
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, seterror] = useState('');
  const [open, setopen] = React.useState(false);
  //Checking For user is already signed Up?
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        console.log("User Logged IN");
        console.log(user);
      } else {
        console.log("User is Signed Out");
      }
    });
  }, []);

  //FOR GOOGLE AUTHENTICATION
  const handleGoogleAuthentication = async () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    try {
      const data = await auth.signInWithPopup(provider);
      const userRef = db.collection('users').doc(auth.currentUser.uid);
      userRef.get().then(
        docsnapshot => {
          if (docsnapshot.exists) {
            userRef.onSnapshot(doc => {
              const name = doc.data().name;
              const follower = doc.data().follower;
              const follower_Count = doc.data().follower_Count;
              const saved = doc.data().saved;
              const noti = doc.data().noti;
              const userData = {
                uid: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: name,
                follower: follower,
                follower_Count: follower_Count,
                saved: saved,
                noti: noti,
              };
              localStorage.setItem("user", JSON.stringify(userData));
              localStorage.setItem('allowed', '1');
              localStorage.setItem('signup', '0');
              history.push('/home');
            })
          }
          else {
            db.collection("users").doc(auth.currentUser.uid).set({
              email: auth.currentUser.email,
              name: auth.currentUser.displayName,
              follower: [],
              follower_Count: 0,
              saved: [],
              profilePic: "",
              description: "No Description to show",
              noti: true,
            });
            console.log(data);
            const userData = {
              uid: auth.currentUser.uid,
              email: auth.currentUser.email,
              name: auth.currentUser.displayName,
              follower: [],
              follower_Count: 0,
              saved: [],
              profilePic: "",
              description: "No Description to show",
              noti: true,
            };
            localStorage.setItem("user", JSON.stringify(userData));
            localStorage.setItem('allowed', '1');
            dispatch({ type: "USER_SIGNUP", payload: userData });
            history.push('/home');
            localStorage.setItem('signup', '1');
          }
        }
      )
      // await db.collection('users').get().then(
      //   snapshot => snapshot.docs.map(doc => {
      //     if(doc.data().email===auth.currentUser.email){
      //       const name=doc.data().name;
      //       const follower=doc.data().follower;
      //       const follower_Count=doc.data().follower_Count;
      //       const saved=doc.data().saved;
      //       const userData = {
      //         uid: auth.currentUser.uid,
      //         email: auth.currentUser.email,
      //         name: name,
      //         follower:follower,
      //         follower_Count:follower_Count,
      //         saved:saved,
      //       };
      //       localStorage.setItem("user", JSON.stringify(userData));
      //       localStorage.setItem('allowed', '1');
      //       localStorage.setItem('signup', '0');
      //       history.push('/home');
      //     }
      //   })
      // )
      // await db.collection("users").doc(auth.currentUser.uid).set({
      //   email: auth.currentUser.email,
      //   name: auth.currentUser.displayName,
      //   follower:[],
      //   follower_Count:0,
      //   saved:[],
      //   profilePic:"",
      //   description:"No Description to show",
      // });
      // console.log(data);
      // const userData = {
      //   uid: auth.currentUser.uid,
      //   email: auth.currentUser.email,
      //   name: auth.currentUser.displayName,
      //   follower:[],
      //   follower_Count:0,
      //   saved:[],
      //   profilePic:"",
      //   description:"No Description to show",
      // };
      // localStorage.setItem("user", JSON.stringify(userData));
      // localStorage.setItem('allowed', '1');
      // dispatch({ type: "USER_SIGNUP", payload: userData });
      // history.push('/home'); 
      // localStorage.setItem('signup', '1');
    } catch (err) {
      console.log(err);
    }
  };
  // Network request for SIGN_UP the user from firebase auth
  const handleSubmitCredentials = async (e) => {
    e.preventDefault();
    try {
      const result = await auth.createUserWithEmailAndPassword(
        email.toString(),
        password
      )

      const user = auth.currentUser;
      await user.sendEmailVerification();

      const uid = user.uid;
      db.collection("users").doc(auth.currentUser.uid).set({
        email,
        name,
        follower: [],
        follower_Count: 0,
        saved: [],
        profilePic: "",
        description: "No Description to show",
        noti: true,
      });

      localStorage.setItem(uid, 'firsttime');
      setopen(true);
      // const userData = {
      //   uid,
      //   email,
      //   name,
      //   follower:[],
      //   follower_Count:0,
      //   saved:[],
      //   profilePic:"",
      //   description:"No Description to show",
      // };
      // console.log(userData);
      // localStorage.setItem("user", JSON.stringify(userData));
      // localStorage.setItem('allowed', '1');
      // dispatch({ type: "USER_SIGNUP", payload: userData });
      // console.log(state);
      // console.log("USER SIGNED UP SUCESSFULLY");
      // localStorage.setItem('signup', '1');
      // history.push(`/home`)
    } catch (err) {
      if (err.code === 'auth/email-already-in-use') {
        seterror('Email Address already registered');
      }
      else if (err.code === 'auth/weak-password') {
        seterror('Password should be of atleast 6 characters')
      }
      console.log(err);
    }
  };

  return (
    <React.Fragment>
      {/* Logo here */}

      <div className='comlogo'>
        <img src={brand} onClick={(e) => window.location.href = '/'} />
      </div>

      {/* Main Content */}
      <div className="content">
        {open ? <VerificatonModal open={open} setOpen={setopen} /> : null}

        <div>

          <form onSubmit={(e) => handleSubmitCredentials(e)}>

            {error !== '' ? error === 'Password should be of atleast 6 characters' ? <p className="passerror">{error}</p> : <p className="passerror">{error}</p> : null}

            <div>

              <h2 className='heading'>Create Account</h2>

              <div style={{ 'margin-bottom': '-10px' }}>
                <label style={{ cursor: 'default' }}>First Name</label>
              </div>
              <input className='input' aria-label="First Name" aria-required="true" autocapitalize="sentences" autocorrect="off" name="firstName" required type="text" onChange={(e) => setName(e.target.value)} />

              <div style={{ 'margin-bottom': '-10px' }}>
                <label style={{ cursor: 'default' }}>Last Name</label>
              </div>
              <input className='input' aria-label="Last Name" aria-required="true" autocapitalize="sentences" autocorrect="off" name="lastName" required required type="text" onChange={(e) => setLastName(e.target.value)} />


              <div style={{ 'margin-bottom': '-10px' }}>
                <label style={{ cursor: 'default' }}>Email Address</label>
              </div>
              <input className='input' aria-label="email" aria-required="true" autocapitalize="off" autocorrect="off" maxlength="75" name="email" required type="email" onChange={(e) => setEmail(e.target.value)} />

              <div style={{ 'margin-bottom': '-10px' }}>
                <label style={{ cursor: 'default' }}>Password</label>
              </div>
              <input className='input' aria-label="Password" aria-required="true" autocapitalize="off" autocorrect="off" name="password" type="password" required onChange={(e) => setPassword(e.target.value)} />

              <p className="tnc-note">
                By clicking Agree & Join or Sign up with Google, You agree to
                Friend a Book's{" "}
                <Link to="/terms" style={{ color: "#3e6ae1" }}>
                  Terms of Service
                </Link>{" "}
                and{" "}
                <Link to="/privacy" style={{ color: "#3e6ae1" }}>
                  Privacy Policy
                </Link>
              </p>

              <div>
                <button type="submit" className='signup-button'>Agree and Join</button>
              </div>

              <div className='or' style={{ 'margin': '30px 0' }}>
                <hr className='hr-left' />
                <div className='or-text' style={{ fontFamily: "Rubik" }}>OR</div>
                <hr className='hr-left' />
              </div>

              <button className='google-button' onClick={handleGoogleAuthentication} style={{ 'margin-bottom': '30px' }}>
                <span>
                  <img src={google} />
                </span>
                <span
                  className='continue'
                  style={{
                    fontFamily: "Rubik",
                  }}
                >
                  Continue With Google
                </span>
              </button>
              {/* 

            <Link to="signup">
              {" "}
              <button className='create-account-button'>CREATE ACCOUNT</button>
            </Link> */}

            </div>

          </form>

          {/* <form onSubmit={(e) => handleSubmitCredentials(e)}>

            {error !== '' ? error === 'Password should be of atleast 6 characters' ? <Para style={{ marginBottom: '0vh', marginTop: '-5vh', color: 'red', fontWeight: 'normal' }}>{error}</Para> : <Para style={{ marginBottom: '0vh', marginTop: '-5vh', color: 'red', fontWeight: 'normal' }}>{error}</Para> : null}

            <h2 className='heading'>Create Account</h2>

            <div>
              <label style={{ cursor: 'default' }}>First Name</label>
            </div>

            <input className='input' required type="text" onChange={(e) => setName(e.target.value)} />

            <div>
              <label style={{ cursor: 'default' }}>Last Name</label>
            </div>

            <input className='input' required type="text" onChange={(e) => setLastName(e.target.value)} />

            <div>
              <label style={{ cursor: 'default' }}>Email Address</label>
            </div>

            <input className='input' required type="email" onChange={(e) => setEmail(e.target.value)} />

            <div>
              <label style={{ cursor: 'default' }}>Password</label>
            </div>

            <input className='input' type="password" required onChange={(e) => setPassword(e.target.value)} />


            <Note>
              By clicking Agree & Join or Sign up with Google, You agree to
              Friend a Book's{" "}
              <Link to="/terms" style={{ color: "#3e6ae1" }}>
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link to="/privacy" style={{ color: "#3e6ae1" }}>
                Privacy Policy
              </Link>
            </Note>
            <JoinButton type="submit">Agree and Join</JoinButton>
            <div style={{ marginBottom: '9vh', marginTop: '6vh', display: 'flex', marginLeft: '4vw' }}>
              <hr style={{ width: '10vw', marginTop: '1.5vh', marginRight: '1vw', marginLeft: '1vw' }} />
              <div style={{
                fontSize: "17px",
                fontFamily: "Rubik",
                fontWeight: 600,
                color: "#595555",
              }}>OR</div>
              <hr style={{ width: '10vw', marginTop: '1.5vh', marginLeft: '1vw', marginRight: '1vw' }} />
            </div>
            <GoogleButton onClick={handleGoogleAuthentication} style={{ marginBottom: '4.72vh', marginLeft: '4vw' }}>
              <span>
                <Google />
              </span>
              <span
                className='cwg'
                style={{
                  fontFamily: "Rubik",
                  position: "relative",
                  fontWeight: 'normal'
                }}
              >
                Continue With Google
              </span>
            </GoogleButton>
          </form> */}

        </div>



      </div>
    </React.Fragment>
  );
};
const Heading = styled(Para)`
  font-size: 40px;
  font-weight: 600;
  font-family: Rubik;
  position: relative;
  color: black;
  right: 15px;
  margin-bottom: 4.5vh;
  margin-left: -1vw;
`;
const Note = styled(Para)`
  color: black;
  text-align: left;
  width: 22vw;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 10vh;
  margin-left: 5vw;
`;
const JoinButton = styled(Button)`
  position: relative;
   height: 7vh;
  margin-left: 4vw;
`;

export default SignUp;
